import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import * as _ from 'underscore';

@Component({
    selector: 'app-horizon-time-range',
    templateUrl: './horizon-time-range.component.html',
    styleUrls: ['./horizon-time-range.component.scss'],
    standalone: false
})
export class HorizonTimeRangeComponent implements OnInit {
    @Input()
    horizon: any;

    @Output()
    updateHorizonTimeRange = new EventEmitter<any>();

    showDropdown = false;
    mouseCursorOnMenu = false;

    defaultTimeRangeList = [
        {value: 0, text: 'Now'},
        {value: 0.25, text: '1 week'},
        {value: 1, text: '1 month'},
        {value: 3, text: '3 months'},
        {value: 6, text: '6 months'},
        {value: 9, text: '9 months'},
        {value: 12, text: '1 year'}/*,
        {value: 18, text: '1.5 years'},
        {value: 24, text: '2 years'},
        {value: 36, text: '3 years'},
        {value: 48, text: '4 years'},
        {value: 60, text: '5 years'},
        {value: 72, text: '6 years'},
        {value: 84, text: '7 years'},
        {value: 96, text: '8 years'},
        {value: 108, text: '9 years'},
        {value: 120, text: '10 years'}*/
    ];

    constructor() {
    }

    ngOnInit() {
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event) {
        let outsideEverythingInPanel = true;
        try {
            outsideEverythingInPanel = !event.target.matches('.horizon-dropdown-menu-panel,.horizon-dropdown-menu-panel div,' +
            '.horizon-dropdown-menu-panel select,.horizon-dropdown-menu-panel button');
        } catch (err) {}
        if ( outsideEverythingInPanel) {
            this.showDropdown = false;
        }
    }

    onHorizonTimeRangeUpdate(horizon) {
        this.updateHorizonTimeRange.emit(horizon);
        this.showDropdown = false;
    }

    selectedValueChange(newValue: string) {
        const from = _.find(this.defaultTimeRangeList, x => x.value === this.horizon.from);
        const to = _.find(this.defaultTimeRangeList, x => x.value === this.horizon.to);
        this.horizon.text = from.text + ' to ' + to.text;
    }

    onDropdownButtonClick(event) {
        this.showDropdown = !this.showDropdown;
        event.stopPropagation();
    }
}
